import { inject, Injectable } from '@angular/core'

import { FileUpload } from 'domain/fileupload'

import { doc, Firestore, setDoc } from '@angular/fire/firestore'
import { deleteObject, getDownloadURL, ref, Storage, StorageError, uploadBytesResumable } from '@angular/fire/storage'
import { Utils } from 'src/app/shared/utils/utils'
import { assertNonNullish } from '../../../../commons/assertions'
import { dataURLtoFile } from '../utils/file.utils'

@Injectable({
	providedIn: 'root',
})
export class FileUploadService {
	private readonly storage = inject(Storage)
	private readonly firestore = inject(Firestore)

	async uploadFile(path: string, file: File): Promise<string>
	async uploadFile(path: string, dataUrl: string, fileName: string): Promise<string>
	async uploadFile(path: string, fileOrDataUrl: File | string, fileName?: string): Promise<string> {
		let fileToUpload: File
		if (typeof fileOrDataUrl === 'string') {
			assertNonNullish(fileName, 'fileName is null or undefined')
			fileToUpload = dataURLtoFile(fileOrDataUrl, fileName)
		} else {
			fileToUpload = fileOrDataUrl
		}

		assertNonNullish(path, 'path is null or undefined')
		const fileStoragePath = `${this.uploadsPath}/${path}`

		const storageRef = ref(this.storage, fileStoragePath)
		const uploadTask = uploadBytesResumable(storageRef, fileToUpload)

		const onUploadError = (error: StorageError) => console.error('Error uploading file:', error)
		await uploadTask.then(null, onUploadError)

		return fileStoragePath
	}

	async deleteFile(fullStoragePath: string): Promise<void> {
		const storageRef = ref(this.storage, fullStoragePath)
		await deleteObject(storageRef)
	}

	/** @deprecated */
	async pushFileToStorage(fileUpload: FileUpload, item: any, table: any, ext: any, folder = ''): Promise<void> {
		let filePath = `${this.uploadsPath}/${item.id}.${ext}`
		if (folder !== '') filePath = `${this.uploadsPath}/${folder}/${item.id}.${ext}`

		const storageRef = ref(this.storage, filePath)
		const uploadTask = uploadBytesResumable(storageRef, fileUpload.file)

		await uploadTask.then()

		const downloadURL = await getDownloadURL(storageRef)
		fileUpload.url = downloadURL
		fileUpload.name = fileUpload.file.name
		return this.saveFileData(fileUpload, item, table)
	}

	/** @deprecated */
	deleteFileUpload(fileUpload: FileUpload) {
		this.deleteFileStorage(fileUpload.name)
	}

	private async saveFileData(fileUpload: FileUpload, item: any, table: any) {
		item.file_name = fileUpload.name
		item.file_url = fileUpload.url

		if (!item.id) item.id = Utils.guid()

		const itemRef = doc(this.firestore, `${table}/${item.id}`)
		await setDoc(itemRef, item, { merge: true })

		return item
	}

	private deleteFileStorage(name: string) {
		//TODO: this probably has to be more general purpose
		const storageRef = ref(this.storage, this.uploadsPath + '/snapshots/' + name)
		// console.log(storageRef, this.uploadsPath + '/snapshots/' + name)
		deleteObject(storageRef)
	}

	private uploadsPath = 'uploads'
}
